(ns ductile.ui.announcements
  (:require [ductile.time.format :as time-format]
            [ductile.ui.components :as ui]
            [ductile.ui.http :as http]
            [ductile.ui.icons :as icons]
            [ductile.ui.locale :refer [tr]]
            [ductile.ui.scene :as scene]
            [ductile.ui.util :as util]
            [inside-out.forms]
            [inside-out.reagent :refer [with-form]]
            [nextjournal.log :as log]
            [reagent.core :as r])
  (:require-macros [ductile.ui.scene.macros :refer [defscene]]))

(defn codes-modal [on-close {:as fahrzeug :fahrzeug/keys [vehicle]}]
  (let [vin (:vehicle/vin vehicle)
        ars-id (str "ARS-ID-" vin)]
    [ui/alert {:open? true :on-close on-close}
     [ui/alert-content {:class "w-[90vw] max-w-[960px]"}
      [ui/modal-close {:on-click on-close}]
      [:div.flex.flex-col.lg:flex-row.lg:items-center {:class "min-h-[260px]"}
       [:div.px-6.py-4.whitespace-nowrap.text-sm.text-gray-500.py-10
        [ui/code39 {:width 550
                    :class "mb-2"
                    :on-click #(.writeText js/navigator.clipboard
                                           (str "ductile.ui.scanner.register_scans([{'de.ductile.app.scanner.data_string': '" vin "', 'de.ductile.app.scanner.label_type': '" "code39" "', 'de.ductile.app.scanner.source': 'scanner'}])"))}
         vin]
        vin]
       [:div.px-6.py-4.whitespace-nowrap.text-sm.text-gray-500.py-10
        [ui/code39 {:width 200
                    :class "mb-2"
                    :on-click #(.writeText js/navigator.clipboard
                                           (str "ductile.ui.scanner.register_scans([{'de.ductile.app.scanner.data_string': '" (subs vin 10) "', 'de.ductile.app.scanner.label_type': '" "code39" "', 'de.ductile.app.scanner.source': 'scanner'}])"))}
         (subs vin 10)]
        (subs vin 10)]
       [:div.px-6.py-4.whitespace-nowrap.text-sm.text-gray-500
        [ui/qr-code {:size 100
                     :class "mb-2"
                     :on-click #(.writeText js/navigator.clipboard
                                            (str "ductile.ui.scanner.register_scans([{'de.ductile.app.scanner.data_string': '" ars-id "', 'de.ductile.app.scanner.label_type': '" "qrcode" "', 'de.ductile.app.scanner.source': 'scanner'}])"))}
         ars-id]
        ars-id]]]]))

(defn qr-code-generator-modal [!visible?]
  [ui/alert {:open? @!visible? :on-close #(reset! !visible? false)}
   [ui/alert-content {:full? true}
    [ui/modal-close {:on-click #(reset! !visible? false)}]
    [:div.flex.justify-between.items-center.py-4.px-6.border-b
     [:h4.mt-0.text-base.font-bold (tr "Generate QR Code")]]
    [:div.bg-slate-200 {:class "min-h-[260px]"}
     (with-form [!form {:qr-code-value ?qr-code-value}]
       [:div.px-6.py-4.flex.flex-col.items-center
        [ui/input {:value (or @?qr-code-value "")
                   :on-input #(reset! ?qr-code-value (.. % -target -value))
                   :placeholder "Enter QR-Code value"
                   :class "w-full"}]
        [:div.border.rounded-md.mt-3.shadow-lg.bg-white.p-1
         {:class "w-[200px] h-[200px]"}
         (when-let [v (seq @?qr-code-value)]
           [ui/qr-code {:size 200} v])]])]]])

(defn announcements-view [announcements]
  (r/with-let [!qr-code-generator-modal-open? (r/atom false)
               !selected-fahrzeug (r/atom nil)]
    [:div.pb-12
      ;; TODO: fix positioning or conditionally position this inside nav?
     [:div.flex.items-center.mb-3.justify-between
      [:h1.text-xl.pl-6 (tr "Announced vehicles")]
      [ui/button {:variant :primary
                  :size 3
                  :on-click #(reset! !qr-code-generator-modal-open? true)} (tr "Generate QR Code")]]
     (when @!qr-code-generator-modal-open?
       [qr-code-generator-modal !qr-code-generator-modal-open?])
     (when @!selected-fahrzeug
       [codes-modal #(reset! !selected-fahrzeug nil) @!selected-fahrzeug])
     [:table.min-w-full.divide-y.divide-gray-200
      [:thead.bg-gray-50
       [:tr
        #_[:th.px-6.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
           {:scope "col"}
           "erwartet"]
        [:th.px-6.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider {:scope "col"} (tr "VIN")]
        #_[:th.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider {:scope "col"} (tr "Ordering customer")]
        [:th.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider {:scope "col"} (tr "Customer")]
        [:th.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider {:scope "col"} (tr "Expected at")]
        #_[:th.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider {:scope "col"} "Kunde"]
        [:th.py-3.px-6.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider {:scope "col"} (tr "Details")]
        [:th]]]
      (if (empty? announcements)
        [:tbody.bg-white.divide-y.divide-gray-200.text-sm
         [:tr [:td.px-6.py-4.whitespace-nowrap.text-md.text-gray-500 {:col-span 7} (tr "No vehicles found")]]]
        (into [:tbody.bg-white.divide-y.divide-gray-200.text-sm {:label "announcements-body"}]
              (map (fn [{:fahrzeug/keys [customer vehicle contract] :as fahrzeug}]
                     [:tr.hover:bg-gray-50.cursor-pointer
                      [:td.px-6.py-2.whitespace-nowrap.text-sm.text-gray-500
                       (:vehicle/vin vehicle)]
                      [:td.py-2.whitespace-nowrap
                       (:customer/name customer)]
                      [:td.py-2.whitespace-nowrap
                       (when-let [expected-datetime (:entry/expected-datetime fahrzeug)]
                         (str (time-format/->str {:format :date} expected-datetime)))]
                      #_[:td.py-4
                         (:customer/name customer)]
                      [:td.py-2.px-6
                       (:contract/description contract)]
                      [:td.py-2.px-6.flex.justify-end
                       [:div.text-gray-400.hover:text-indigo-600
                        {:on-click #(reset! !selected-fahrzeug fahrzeug)}
                        icons/barcode-scanner]]]))
              (sort-by (juxt (comp - :entry/expected-datetime)
                             (comp :vehicle/vin :fahrzeug/vehicle)) announcements)))]]))


(defn render-announcements [_result _match]
  ;; TODO: should compound-name not come from match?
  (let [compound-name (util/current-compound-name)]
    [ui/loading-promise-view announcements-view (http/announcements compound-name)]))

(defscene show-announcement-loading
  [announcements-view {:loading? true}])

(defscene show-announcement-error
  [announcements-view {:error "This is an example error message."}])

(defscene show-announcements
  [announcements-view
   [{:fahrzeug/customer {:customer/name "Schwarz Beschaffung GmbH"},
     :fahrzeug/vehicle {:vehicle/vin "WBA11AK0X07G69761"},
     :entry/expected-datetime #inst"2021-10-08T00:00:00.000-00:00"}
    {:fahrzeug/customer {:customer/name "Schwarz Beschaffung GmbH"},
     :fahrzeug/vehicle {:vehicle/vin "WBA31DZ090FK30229"},
     :entry/expected-datetime #inst"2021-10-08T00:00:00.000-00:00"}
    {:fahrzeug/customer {:customer/name "Schwarz Beschaffung GmbH"},
     :fahrzeug/vehicle {:vehicle/vin "WBA31DZ060FK40233"},
     :entry/expected-datetime #inst"2021-10-08T00:00:00.000-00:00"}]])
